import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useLocation } from 'quartz-routing/react-router';
import { jsx as _jsx } from "react/jsx-runtime";
export const useTabsConfig = ({
  isPartner
}) => {
  const {
    isMobileNavbar
  } = useMediaQuery();
  const {
    pathname
  } = useLocation();
  const isViewingOtherUserProfile = /^\/profile\/\d+$/.test(pathname);
  const tabs = [{
    exact: true,
    tabId: 'home',
    to: '/',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academy-navigation-lib.ACPage.tabs.home"
    })
  }, {
    exact: true,
    tabId: 'my-learning',
    to: '/my-learning',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academy-navigation-lib.ACPage.tabs.myLearning"
    })
  }, {
    exact: true,
    tabId: 'watch-later',
    to: '/watch-later',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academy-navigation-lib.ACPage.tabs.watchLater"
    })
  }, {
    tabId: 'my-playlists',
    to: '/saved-items/playlists',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academy-navigation-lib.ACPage.tabs.myPlaylists"
    })
  }, {
    exact: isViewingOtherUserProfile,
    tabId: 'my-profile',
    to: '/profile',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academy-navigation-lib.ACPage.tabs.myProfile"
    })
  }];
  if (!isMobileNavbar) {
    tabs.push({
      tabId: 'my-team',
      to: '/my-team',
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.tabs.myTeam"
      })
    });
  }
  if (isPartner) {
    tabs.push({
      exact: true,
      tabId: 'partner',
      to: '/partners',
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.tabs.partnerTraining"
      })
    });
  }
  return tabs;
};